import { render, staticRenderFns } from "./pageModule.vue?vue&type=template&id=3973c70b&scoped=true"
import script from "./pageModule.vue?vue&type=script&lang=js"
export * from "./pageModule.vue?vue&type=script&lang=js"
import style0 from "./pageModule.vue?vue&type=style&index=0&id=3973c70b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3973c70b",
  null
  
)

export default component.exports